import styled from 'styled-components';
import { Checkbox, Modal } from 'antd';
import { Cart3 } from '@styled-icons/bootstrap';
import { ListAlt } from '@styled-icons/fa-regular';

interface StyledProps {
  columns?: number;
  full?: boolean;
  buttonContainer?: boolean;
}

const inputContainerWidth = '17.25rem';
export const ContructionIdentificationInputContainer = styled.div<StyledProps>`
  width: 100%;

  position: relative;

  .hefesto-datefield__right-icon-wrapper span {
    display: flex;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    min-width: ${(props) =>
      props.columns
        ? `${props.columns * 86}px`
        : props.full
        ? '380px'
        : inputContainerWidth};

    &.double-width {
      width: 100%;
    }

    &.padding {
      padding: 1rem;
    }

    &.last-order {
      width: unset;
      flex: 0.5;
    }

    &.last-order-facelift {
      width: unset;
      flex: 0.5;
    }

    &.facelift {
      flex: 0.8;
    }
  }

  & > .title {
    color: ${({ theme }) => theme.colors.grayDark2};
    font-weight: bold;
    font-size: 0.875rem;
    margin-top: 0.175rem;
  }

  & > .title-disabled {
    color: ${({ theme }) => theme.colors.grayDark2};
    font-weight: bold;
    font-size: 0.875rem;
    margin-top: 0.175rem;
  }

  &:not(:last-child) {
    margin-right: 1rem;
  }

  & input:disabled {
    color: ${({ theme }) => theme.colors.grayDark};
  }

  & input.repeated-order-number {
    border-color: ${({ theme }) => theme.colors.lightBlue};
    box-shadow: 0 0 0 2px rgb(24 144 255 / 20%);
  }

  & > .ant-select {
    width: 100%;
  }

  & > .block-title {
    color: ${({ theme }) => theme.colors.black};
    font-weight: bold;
    font-size: 1.125rem;
  }

  & > .ant-checkbox-wrapper {
    margin-top: 2.25rem;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobileL}) {
      margin-top: 2.25rem;
    }
  }

  & > button.search-contract {
    width: 100%;
    margin-top: 1.5rem;
  }

  &.has-error {
    padding-bottom: 1.875rem;
  }

  .hefesto-datefield__wrapper {
    min-height: 2.813rem;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    width: 100%;
  }
`;

export const ConstructionIdentificationBlock = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0.25rem;
  padding: 0.75rem 0.75rem 0.125rem;
  margin: 0.75rem 0;

  & > .title {
    color: ${({ theme }) => theme.colors.grayDark2};
    font-weight: bold;
    font-size: 0.875rem;
  }

  & > span {
    color: ${({ theme }) => theme.colors.grayDark2};
    font-size: 0.875rem;
  }

  & input:disabled {
    color: ${({ theme }) => theme.colors.grayDark};
  }

  & > .block-title {
    color: ${({ theme }) => theme.colors.black};
    font-weight: bold;
    font-size: 1.125rem;
  }
`;

export const ConstructionContainer = styled.div<StyledProps>`
  ${(props) =>
    props.buttonContainer &&
    `
      position: sticky;
      bottom: 0;
      left: 0;
      z-index: 99;
  `};

  @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    display: flex;
    flex-direction: column;
  }

  background-color: ${({ theme }) => theme.colors.white};
  padding: ${(props) =>
    props.buttonContainer
      ? '0 1.875rem 0 1.875rem'
      : '1.5rem 1.875rem 3rem 1.875rem'};

  :nth-child(1) {
    padding-bottom: 1.5rem;
  }

  .hefesto-input-wrapper__support-message {
    display: block;
  }

  margin-top: 0.5rem;

  & > header > h2 {
    padding-top: 1rem;
  }

  & > span.subtitle {
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.grayDark4};
    font-family: ${({ theme }) => theme.fonts.workSans};
    margin-bottom: 1rem;
    display: block;
  }

  & .hefesto-title h2 {
    color: #495961;
  }

  .wrapperWorkDetails {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .workDetails {
    gap: 24px;
    display: grid;
    grid-template-columns: 30% auto;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    .workDetails {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
  }
`;

export const ConstructionIdentificationContentBlock = styled.div`
  display: flex;
  flex-direction: flex-start;

  @media (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  &.last-order {
    flex-wrap: wrap;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobileL}) {
      gap: 1.5rem;
    }
  }
`;

export const InputDisabledBlock = styled.div`
  & > .title {
    color: ${({ theme }) => theme.colors.grayDark2};
    font-weight: bold;
    font-size: 0.875rem;
  }

  & input:disabled {
    color: ${({ theme }) => theme.colors.grayDark};
    width: 36%;
  }
`;

export const CheckBoxGroup = styled(Checkbox.Group)`
  display: flex;
  flex-direction: column;

  & .ant-checkbox-group-item:not(:last-child) {
    margin-bottom: 0.5rem;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobileL}) {
      margin-bottom: 0.25rem;
    }
  }
`;

export const CheckNewContractModal = styled(Modal)`
  & .ant-modal-body {
    padding: 1rem;
    color: ${({ theme }) => theme.colors.grayDark2};

    & > h3 {
      font-size: 1rem;
      font-weight: 600;
      margin-bottom: 0.5rem;
    }

    & > span {
      font-size: 0.875rem;
    }
  }
`;

export const OrderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.mobileL}) {
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
  }

  & > span.last-order {
    font-size: 0.75rem;
    color: ${({ theme }) => theme.colors.grayDark2};
    max-width: 13rem;
    min-width: 6.5rem;
    word-break: break-all;
    margin-right: 1rem;
  }

  & > div.actions {
    display: flex;
    flex-direction: column;
    margin-top: 0.5rem;
    width: 100%;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      flex-direction: row;
      margin-top: unset;
    }

    & > button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      font-size: 0.75rem;

      &:first-child {
        margin-bottom: 1rem;
        @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
          margin-right: 1rem;
          margin-bottom: unset;
        }
      }
    }
  }
`;

export const ListIcon = styled(ListAlt)`
  width: 1rem;
  margin-right: 0.5rem;
`;

export const CartIcon = styled(Cart3)`
  width: 1rem;
  margin-right: 0.5rem;
`;

export const ButtonActionContainer = styled.div`
  display: flex;
  gap: 1.5rem;
  flex: 1;
  align-items: flex-end;
  justify-content: center;

  button {
    flex: 0.5;
    height: 3rem;
  }
`;
export const SearchContractButtonContainer = styled.div`
  margin-top: 0.5rem;
  padding-bottom: 0.5rem;
`;

export const DeliveryNotesContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white};

  textarea,
  .hefesto-textarea {
    width: 100%;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 1rem;
  padding: 1.25rem 0;
  justify-content: flex-end;

  & > button {
    width: 16.875rem;
  }
`;

export const Subtitle = styled.p`
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.grayDark4};
  font-family: ${({ theme }) => theme.fonts.workSans};
`;

export const Message = styled.h4`
  color: #495961;
  font-size: 24px;
  line-height: 32px;
  font-family: 'Source Sans Pro';
  font-weight: 600;
  text-align: center;
  width: 31rem;
`;
